/* TourStock trade and bulk enquiry form. Prefix: tte- */
(function () {
  "use strict";

  var root = document.getElementById("tte");
  if (!root) return;

  var STORE_KEY = "ts-trade-enquiry-v1";
  var endpoint = root.getAttribute("data-endpoint");
  var contactAction = root.getAttribute("data-contact-action") || "/contact";
  var form = document.getElementById("tte-form");
  var q = root.querySelector("[data-tte-q]");
  var suggestBox = root.querySelector("[data-tte-suggest]");
  var linesEl = root.querySelector("[data-tte-lines]");
  var emptyEl = root.querySelector("[data-tte-empty]");
  var pasteEl = root.querySelector("[data-tte-paste]");
  var listEl = root.querySelector("[data-tte-list]");
  var listCount = root.querySelector("[data-tte-list-count]");
  var summaryEmpty = root.querySelector("[data-tte-summary-empty]");
  var summaryBody = root.querySelector("[data-tte-summary-body]");
  var summaryCount = root.querySelector("[data-tte-summary-count]");
  var summaryList = root.querySelector("[data-tte-summary-list]");
  var submitBtn = root.querySelector("[data-tte-submit]");
  var submitLabel = root.querySelector("[data-tte-submit-label]");
  var successEl = root.querySelector("[data-tte-success]");
  var bar = root.querySelector("[data-tte-bar]");
  var barText = root.querySelector("[data-tte-bar-text]");
  var postcodeField = root.querySelector("[data-tte-postcode-field]");
  var recsEl = root.querySelector("[data-tte-recs]");
  var recsList = root.querySelector("[data-tte-recs-list]");
  var addCustomBtn = root.querySelector("[data-tte-add-custom]");
  var addCartBtn = root.querySelector("[data-tte-add-cart]");
  var cartCount = root.querySelector("[data-tte-cart-count]");
  var convertBtn = root.querySelector("[data-tte-list-convert]");
  var fileInput = root.querySelector("[data-tte-file]");
  var summaryEst = root.querySelector("[data-tte-summary-est]");
  var matcher = window.TsTradeMatch || null;

  var lines = [];
  var submissionId = newId();
  var submitting = false;
  var suggestItems = [];
  var activeIndex = -1;
  var searchTimer = null;
  var searchController = null;
  var saveTimer = null;

  function newId() {
    try {
      if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
      }
    } catch (e) {
      /* fall through */
    }
    return "tte-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }

  function el(tag, attrs, kids) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        var value = attrs[key];
        if (value === null || value === undefined || value === false) return;
        if (key === "class") node.className = value;
        else if (key === "text") node.textContent = value;
        else node.setAttribute(key, value === true ? "" : value);
      });
    }
    (kids || []).forEach(function (kid) {
      if (kid) node.appendChild(typeof kid === "string" ? document.createTextNode(kid) : kid);
    });
    return node;
  }

  function money(pence) {
    return "£" + (pence / 100).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function clampQty(value) {
    var n = parseInt(value, 10);
    if (!isFinite(n) || n < 1) return 1;
    return Math.min(n, 100000);
  }

  /* ---------- Lines ---------- */

  function selectedVariant(line) {
    if (!line.variants || !line.variants.length) return null;
    for (var i = 0; i < line.variants.length; i += 1) {
      if (String(line.variants[i].id) === String(line.variantId)) return line.variants[i];
    }
    return line.variants[0];
  }

  function variantLabel(v) {
    var name = v.title && v.title !== "Default Title" ? v.title : "";
    return (name || "Standard") + " · " + money(v.price) + " ex VAT" + (v.available ? "" : " · out of stock");
  }

  function lineMeta(line) {
    var v = selectedVariant(line);
    if (!v) {
      return line.handle
        ? (line.priceText ? line.priceText + ". " : "") + "We will check the price and options for you."
        : "Not on the website? No problem, we will source it and quote you.";
    }
    var parts = [];
    if (v.sku) parts.push("SKU " + v.sku);
    parts.push("List price " + money(v.price) + " ex VAT");
    return parts.join(" · ");
  }

  function labelled(text, input) {
    return el("label", { class: "tte-line__field" }, [el("span", { class: "tte-line__field-label", text: text }), input]);
  }

  function buildLine(line, isNew) {
    var li = el("li", { class: "tte-line" + (isNew ? " is-new" : ""), "data-line": line.uid });
    var v = selectedVariant(line);
    var image = line.image
      ? el("img", { class: "tte-line__img", src: line.image, alt: "", width: "56", height: "56", loading: "lazy" })
      : el("div", { class: "tte-line__ph", "aria-hidden": "true", text: line.handle ? "Product" : "Custom item" });

    var isCustom = line.kind === "text";
    var titleInput = null;
    var title;
    if (isCustom) {
      titleInput = el("input", {
        class: "tte-line__text tte-line__name",
        type: "text",
        maxlength: "200",
        placeholder: "What do you need? e.g. Neutrik NC3FXX-B XLR female",
        "aria-label": "Item name",
        value: line.title || "",
      });
      title = el("p", { class: "tte-line__title" }, [el("span", { class: "tte-line__badge", text: "We will source this" })]);
    } else {
      title = el("p", { class: "tte-line__title" }, [line.title]);
    }
    var flag = el("span", { class: "tte-line__flag", hidden: true, text: "Out of stock" });
    title.appendChild(flag);
    var meta = el("p", { class: "tte-line__meta" });
    meta.textContent = lineMeta(line);
    var stockNote = el("p", { class: "tte-line__meta", hidden: true, text: "Out of stock right now. We will say what is possible in your quote." });

    var matchSlot = el("div", { class: "tte-match-slot", "aria-live": "polite" });
    var main = el("div", { class: "tte-line__main" }, [title]);
    if (titleInput) main.appendChild(titleInput);
    main.appendChild(meta);
    main.appendChild(stockNote);
    main.appendChild(matchSlot);
    if (line.requested && !isCustom) {
      main.appendChild(el("p", { class: "tte-line__meta tte-line__asked", text: "You asked for: " + line.requested }));
    }

    var select = null;
    if (line.variants && line.variants.length > 1) {
      select = el("select", { class: "tte-line__text", "aria-label": "Option for " + line.title });
      line.variants.forEach(function (variant) {
        var opt = el("option", { value: String(variant.id), text: variantLabel(variant) });
        if (String(variant.id) === String(line.variantId)) opt.selected = true;
        select.appendChild(opt);
      });
      main.appendChild(select);
    }

    var note = el("input", {
      class: "tte-line__text",
      type: "text",
      maxlength: "300",
      placeholder: line.variants || line.handle ? "Note for this item (optional)" : "Size, brand, colour or anything that helps us find it",
      "aria-label": "Note for " + line.title,
      value: line.note || "",
    });
    main.appendChild(isCustom ? labelled("Details", note) : note);

    if (isCustom) {
      var ref = el("input", {
        class: "tte-line__text",
        type: "text",
        maxlength: "300",
        placeholder: "Optional",
        "aria-label": "Link, part number or brand for this item",
        value: line.reference || "",
      });
      var altBox = el("input", { type: "checkbox" });
      if (line.alt) altBox.checked = true;
      var alt = el("label", { class: "tte-line__alt" }, [altBox, el("span", { text: "A close equivalent is fine" })]);
      main.appendChild(labelled("Link or part number", ref));
      main.appendChild(el("div", { class: "tte-line__extras" }, [alt]));
      ref.addEventListener("input", function () {
        line.reference = ref.value;
        changed();
      });
      altBox.addEventListener("change", function () {
        line.alt = altBox.checked;
        changed();
      });
      titleInput.addEventListener("input", function () {
        line.title = titleInput.value;
        clearTimeout(line.matchTimer);
        line.matchTimer = setTimeout(function () {
          checkMatch(line);
        }, 900);
        changed();
      });
      titleInput.addEventListener("blur", function () {
        clearTimeout(line.matchTimer);
        checkMatch(line);
      });
      titleInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          clearTimeout(line.matchTimer);
          checkMatch(line);
          qty.focus();
          qty.select();
        }
      });
    }

    var minus = el("button", { type: "button", "aria-label": "One fewer", text: "−" });
    var plus = el("button", { type: "button", "aria-label": "One more", text: "+" });
    var qty = el("input", {
      type: "number",
      inputmode: "numeric",
      min: "1",
      max: "100000",
      value: String(line.qty),
      "aria-label": "Quantity of " + line.title,
    });
    var qtyBox = el("div", { class: "tte-qty" }, [minus, qty, plus]);
    var presets = el("div", { class: "tte-presets", role: "group", "aria-label": "Quick quantities" });
    [10, 25, 50, 100].forEach(function (n) {
      presets.appendChild(el("button", { type: "button", "data-qty": String(n), "aria-label": "Set quantity to " + n, text: String(n) }));
    });
    var remove = el("button", { type: "button", class: "tte-remove", "aria-label": "Remove " + line.title, text: "Remove" });
    var side = el("div", { class: "tte-line__side" }, [qtyBox, presets, remove]);

    li.appendChild(image);
    li.appendChild(main);
    li.appendChild(side);
    line.slot = matchSlot;
    line.titleInput = titleInput;

    function paintStock() {
      var current = selectedVariant(line);
      var out = !!current && current.available === false;
      flag.hidden = !out;
      stockNote.hidden = !out;
      meta.textContent = lineMeta(line);
    }
    paintStock();

    function setQty(n) {
      line.qty = clampQty(n);
      qty.value = String(line.qty);
      changed();
    }
    minus.addEventListener("click", function () {
      setQty(line.qty - 1);
    });
    plus.addEventListener("click", function () {
      setQty(line.qty + 1);
    });
    qty.addEventListener("input", function () {
      var n = parseInt(qty.value, 10);
      if (isFinite(n) && n >= 1) {
        line.qty = clampQty(n);
        changed();
      }
    });
    qty.addEventListener("blur", function () {
      setQty(qty.value);
    });
    presets.addEventListener("click", function (event) {
      var btn = event.target.closest("button[data-qty]");
      if (btn) setQty(btn.getAttribute("data-qty"));
    });
    note.addEventListener("input", function () {
      line.note = note.value;
      changed();
    });
    if (select) {
      select.addEventListener("change", function () {
        line.variantId = select.value;
        paintStock();
        changed();
      });
    }
    remove.addEventListener("click", function () {
      lines = lines.filter(function (l) {
        return l.uid !== line.uid;
      });
      li.remove();
      changed();
      q.focus();
    });
    return li;
  }

  function addLine(line, quiet, index) {
    line.uid = line.uid || newId();
    line.qty = clampQty(line.qty || 1);
    var node = buildLine(line, !quiet);
    if (typeof index === "number" && index >= 0 && index < lines.length) {
      lines.splice(index, 0, line);
      linesEl.insertBefore(node, linesEl.children[index] || null);
    } else {
      lines.push(line);
      linesEl.appendChild(node);
    }
    line.node = node;
    changed();
    if (!quiet) {
      node.scrollIntoView({ block: "nearest", behavior: "smooth" });
      var focusTarget = line.kind === "text" && !line.title ? line.titleInput : node.querySelector(".tte-qty input");
      if (focusTarget) {
        focusTarget.focus();
        if (focusTarget.select) focusTarget.select();
      }
    }
    if (line.kind === "product" && line.productId && !quiet) loadRecs(line.productId);
    return node;
  }

  function bumpExisting(productId, variantId, by) {
    for (var i = 0; i < lines.length; i += 1) {
      var l = lines[i];
      if (l.productId && String(l.productId) === String(productId) && String(l.variantId) === String(variantId)) {
        l.qty = clampQty(l.qty + (by || 1));
        var node = linesEl.querySelector('[data-line="' + l.uid + '"] .tte-qty input');
        if (node) {
          node.value = String(l.qty);
          node.focus();
          node.select();
        }
        changed();
        return true;
      }
    }
    return false;
  }

  function addProductByHandle(handle, wantedVariant, qty, suggestImage, extra) {
    return paced("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (p) {
        var variants = (p.variants || []).map(function (v) {
          return {
            id: v.id,
            title: v.title,
            sku: v.sku || "",
            price: v.price,
            available: v.available !== false,
          };
        });
        var chosen = variants[0];
        if (wantedVariant) {
          variants.forEach(function (v) {
            if (String(v.id) === String(wantedVariant)) chosen = v;
          });
        } else {
          for (var i = 0; i < variants.length; i += 1) {
            if (variants[i].available) {
              chosen = variants[i];
              break;
            }
          }
        }
        if (!chosen) throw new Error("no variants");
        if (bumpExisting(p.id, chosen.id, qty || 1)) return;
        var image = p.featured_image || suggestImage || "";
        if (image && image.indexOf("//") === 0) image = "https:" + image;
        if (image && image.indexOf("cdn.shopify.com") > -1) {
          image += (image.indexOf("?") > -1 ? "&" : "?") + "width=120";
        }
        addLine({
          kind: "product",
          productId: p.id,
          handle: handle,
          title: p.title,
          variants: variants,
          variantId: chosen.id,
          image: image,
          qty: qty || 1,
          note: (extra && extra.note) || "",
          requested: (extra && extra.requested) || undefined,
        }, false, extra && typeof extra.index === "number" ? extra.index : undefined);
      });
  }

  function addHandleLine(p, qty, variantId) {
    var image = p.image || "";
    if (image && image.indexOf("//") === 0) image = "https:" + image;
    addLine({
      kind: "product",
      handle: p.handle,
      title: String(p.title || p.handle).slice(0, 200),
      image: image,
      variantId: variantId || "",
      qty: qty || 1,
      note: "",
    });
  }

  function addTextLine(text, qty) {
    var title = (text || "").trim();
    if (!title) return null;
    var line = { kind: "text", title: title.slice(0, 200), qty: qty || 1, note: "", declined: [] };
    addLine(line);
    checkMatch(line);
    return line;
  }

  function addBlankCustomLine() {
    var line = { kind: "text", title: "", qty: 1, note: "", declined: [] };
    addLine(line);
    return line;
  }

  /* ---------- Summary, bar, save ---------- */

  function totalUnits() {
    return activeLines().reduce(function (sum, l) {
      return sum + l.qty;
    }, 0);
  }

  function pastedCount() {
    return (listEl.value || "")
      .split(/\r?\n/)
      .filter(function (s) {
        return s.trim();
      }).length;
  }

  function paintSummary() {
    var pasted = pastedCount();
    emptyEl.hidden = lines.length > 0;
    if (!activeLines().length && !pasted) {
      summaryEmpty.hidden = false;
      summaryBody.hidden = true;
      return;
    }
    summaryEmpty.hidden = true;
    summaryBody.hidden = false;
    var bits = [];
    var count = activeLines().length;
    if (count) bits.push(count + (count === 1 ? " item" : " items") + ", " + totalUnits() + " units");
    if (pasted) bits.push("pasted list of " + pasted + (pasted === 1 ? " line" : " lines"));
    summaryCount.textContent = bits.join(" + ");
    summaryList.textContent = "";
    var listed = 0;
    var custom = 0;
    var total = 0;
    lines.forEach(function (l) {
      if (!lineTitle(l)) return;
      var v = selectedVariant(l);
      var label = l.title;
      if (l.kind === "text") {
        custom += 1;
        label += " (we will source)";
      } else if (v && isFinite(v.price)) {
        listed += 1;
        total += v.price * l.qty;
      }
      summaryList.appendChild(el("li", null, [el("span", { text: label }), el("span", { text: "× " + l.qty })]));
    });
    var bitsEst = [];
    if (listed) bitsEst.push("Catalogue items at list price: " + money(total) + " ex VAT");
    if (custom) bitsEst.push(custom + (custom === 1 ? " item" : " items") + " we will price for you");
    summaryEst.textContent = bitsEst.length ? bitsEst.join(". ") + ". Your quote confirms the final prices." : "";
    summaryEst.hidden = !bitsEst.length;
  }

  function lineTitle(l) {
    return String(l.title || "").trim();
  }

  function activeLines() {
    return lines.filter(function (l) {
      return lineTitle(l);
    });
  }

  function paintBar() {
    var pasted = pastedCount();
    var any = activeLines().length > 0 || pasted > 0;
    if (!any || successEl.hidden === false) {
      bar.hidden = true;
      return;
    }
    var bits = [];
    var n = activeLines().length;
    if (n) bits.push(n + (n === 1 ? " item" : " items"));
    if (pasted) bits.push("list");
    barText.textContent = bits.join(" + ") + " ready";
    bar.hidden = barHidden;
  }

  var barHidden = false;

  function changed() {
    paintSummary();
    paintBar();
    clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 400);
  }

  function formValues() {
    var f = form.elements;
    return {
      timing: radio("timing"),
      frequency: radio("frequency"),
      fulfilment: radio("fulfilment"),
      customerType: radio("customerType"),
      neededBy: f.neededBy.value,
      postcode: f.postcode.value,
      name: f.name.value,
      company: f.company.value,
      email: f.email.value,
      phone: f.phone.value,
      notes: f.notes.value,
      pasted: listEl.value,
    };
  }

  function radio(name) {
    var checked = form.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : "";
  }

  function setRadio(name, value) {
    var node = form.querySelector('input[name="' + name + '"][value="' + value + '"]');
    if (node) node.checked = true;
  }

  var RUNTIME_KEYS = { slot: 1, titleInput: 1, matchTimer: 1, node: 1, matching: 1 };

  function plain(line) {
    var out = {};
    Object.keys(line).forEach(function (key) {
      if (!RUNTIME_KEYS[key]) out[key] = line[key];
    });
    return out;
  }

  function save() {
    try {
      localStorage.setItem(
        STORE_KEY,
        JSON.stringify({ at: Date.now(), form: formValues(), lines: lines.map(plain) })
      );
    } catch (e) {
      /* private mode or full storage: the form still works */
    }
  }

  function clearSaved() {
    try {
      localStorage.removeItem(STORE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function restore() {
    var saved;
    try {
      saved = JSON.parse(localStorage.getItem(STORE_KEY) || "null");
    } catch (e) {
      saved = null;
    }
    if (!saved || Date.now() - saved.at > 14 * 24 * 3600 * 1000) return false;
    var v = saved.form || {};
    ["timing", "frequency", "fulfilment", "customerType"].forEach(function (k) {
      if (v[k]) setRadio(k, v[k]);
    });
    var f = form.elements;
    ["neededBy", "postcode", "notes"].forEach(function (k) {
      if (v[k]) f[k].value = v[k];
    });
    ["name", "company", "email", "phone"].forEach(function (k) {
      if (v[k] && !f[k].value) f[k].value = v[k];
    });
    if (v.pasted) {
      listEl.value = v.pasted;
      pasteEl.open = true;
    }
    (saved.lines || []).forEach(function (l) {
      if (l && l.title) addLine(l, true);
    });
    return lines.length > 0 || !!v.pasted;
  }

  /* ---------- Search ---------- */

  function closeSuggest() {
    suggestBox.hidden = true;
    q.setAttribute("aria-expanded", "false");
    q.removeAttribute("aria-activedescendant");
    activeIndex = -1;
  }

  function optionId(i) {
    return "tte-opt-" + i;
  }

  function setActive(i) {
    activeIndex = i;
    var nodes = suggestBox.querySelectorAll("[role=option]");
    nodes.forEach(function (n, idx) {
      n.setAttribute("aria-selected", idx === i ? "true" : "false");
      if (idx === i) {
        n.scrollIntoView({ block: "nearest" });
        q.setAttribute("aria-activedescendant", n.id);
      }
    });
  }

  function paintSuggest(text, products, loading) {
    suggestBox.textContent = "";
    suggestItems = [];
    products.forEach(function (p) {
      suggestItems.push({ type: "product", product: p });
    });
    if (text.trim()) suggestItems.push({ type: "text", text: text.trim() });

    if (loading && !products.length) {
      suggestBox.appendChild(el("li", { class: "tte-suggest__empty", text: "Searching…" }));
    }
    suggestItems.forEach(function (item, i) {
      var btn;
      if (item.type === "product") {
        var p = item.product;
        var img = p.image
          ? el("img", { src: p.image + (p.image.indexOf("?") > -1 ? "&" : "?") + "width=96", alt: "", width: "48", height: "48", loading: "lazy" })
          : el("span", { class: "tte-opt-ph", text: "?" });
        var price = p.price_min && p.price_min !== "0.00" ? "From £" + p.price_min + " ex VAT" : "";
        var sub = [price, p.available === false ? "Out of stock" : ""].filter(Boolean).join(" · ");
        btn = el("div", { class: "tte-opt-btn", role: "option", id: optionId(i), "aria-selected": "false", "data-i": String(i) }, [
          img,
          el("span", { class: "tte-opt-text" }, [el("strong", { text: p.title }), sub ? el("small", { text: sub }) : null]),
        ]);
      } else {
        btn = el("div", { class: "tte-opt-btn", role: "option", id: optionId(i), "aria-selected": "false", "data-i": String(i) }, [
          el("span", { class: "tte-opt-ph", text: "+" }),
          el("span", { class: "tte-opt-text" }, [
            el("strong", { text: 'Not listed? Add "' + item.text + '" and we will source it' }),
            el("small", { text: "We will check it against our range and quote you." }),
          ]),
        ]);
      }
      var li = el("li", null, [btn]);
      suggestBox.appendChild(li);
    });
    if (!suggestItems.length && !loading) {
      suggestBox.appendChild(el("li", { class: "tte-suggest__empty", text: "Keep typing to search." }));
    }
    suggestBox.hidden = false;
    q.setAttribute("aria-expanded", "true");
    activeIndex = -1;
  }

  function runSearch(text) {
    if (searchController) searchController.abort();
    if (text.trim().length < 2) {
      paintSuggest(text, [], false);
      if (!text.trim()) closeSuggest();
      return;
    }
    paintSuggest(text, [], true);
    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(text.trim()) +
      "&resources%5Btype%5D=product&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last";
    searchController = window.AbortController ? new AbortController() : null;
    fetch(url, { headers: { Accept: "application/json" }, signal: searchController ? searchController.signal : undefined })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (q.value.trim() === text.trim()) paintSuggest(text, products, false);
      })
      .catch(function (e) {
        if (e && e.name === "AbortError") return;
        paintSuggest(text, [], false);
      });
  }

  function choose(i) {
    var item = suggestItems[i];
    if (!item) return;
    closeSuggest();
    if (item.type === "text") {
      addTextLine(item.text);
      q.value = "";
      return;
    }
    var p = item.product;
    q.value = "";
    addProductByHandle(p.handle, null, 1, p.image).catch(function () {
      addHandleLine(p);
    });
  }

  q.addEventListener("input", function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      runSearch(q.value);
    }, 200);
  });
  q.addEventListener("focus", function () {
    if (q.value.trim().length >= 2) runSearch(q.value);
  });
  q.addEventListener("keydown", function (event) {
    var open = !suggestBox.hidden;
    if (event.key === "ArrowDown" && open) {
      event.preventDefault();
      setActive(Math.min(activeIndex + 1, suggestItems.length - 1));
    } else if (event.key === "ArrowUp" && open) {
      event.preventDefault();
      setActive(Math.max(activeIndex - 1, 0));
    } else if (event.key === "Enter") {
      event.preventDefault();
      if (open && activeIndex >= 0) choose(activeIndex);
      else if (open && suggestItems.length) choose(0);
      else if (q.value.trim()) {
        addTextLine(q.value);
        q.value = "";
        closeSuggest();
      }
    } else if (event.key === "Escape") {
      closeSuggest();
    }
  });
  suggestBox.addEventListener("mousedown", function (event) {
    event.preventDefault();
  });
  suggestBox.addEventListener("click", function (event) {
    var node = event.target.closest("[data-i]");
    if (node) choose(parseInt(node.getAttribute("data-i"), 10));
  });
  document.addEventListener("click", function (event) {
    if (!event.target.closest("[data-tte-search]")) closeSuggest();
  });

  root.querySelectorAll("[data-tte-try]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      q.value = btn.getAttribute("data-tte-try");
      q.focus();
      runSearch(q.value);
    });
  });

  /* ---------- Storefront requests, paced so Shopify does not rate limit the visitor ---------- */

  var lastCall = 0;
  var chain = Promise.resolve();
  var cache = {};

  function paced(url) {
    if (cache[url]) return cache[url];
    var run = chain.then(function () {
      var wait = Math.max(0, lastCall + 220 - Date.now());
      return new Promise(function (resolve) {
        setTimeout(resolve, wait);
      });
    }).then(function () {
      lastCall = Date.now();
      return fetch(url, { headers: { Accept: "application/json" } });
    }).then(function (r) {
      if (r.status !== 429) return r;
      return new Promise(function (resolve) {
        setTimeout(resolve, 1800);
      }).then(function () {
        lastCall = Date.now();
        return fetch(url, { headers: { Accept: "application/json" } });
      });
    }).then(function (r) {
      if (!r.ok) throw new Error("status " + r.status);
      return r.json();
    });
    chain = run.catch(function () {});
    cache[url] = run;
    run.catch(function () {
      delete cache[url];
    });
    return run;
  }

  function suggestUrl(text, limit) {
    return (
      "/search/suggest.json?q=" +
      encodeURIComponent(text.trim()) +
      "&resources%5Btype%5D=product&resources%5Blimit%5D=" +
      limit +
      "&resources%5Boptions%5D%5Bunavailable_products%5D=last"
    );
  }

  /* ---------- Close-match suggestions for items we do not list ---------- */

  function matchInput(p) {
    return {
      title: p.title,
      vendor: p.vendor,
      type: p.product_type || p.type,
      available: p.available,
      variants: (p.variants || []).map(function (v) {
        return { id: v.id, title: v.title === "Default Title" ? "" : v.title, sku: v.sku || "", available: v.available !== false };
      }),
    };
  }

  function describeMatch(p, result, fromJs) {
    var variant = null;
    (p.variants || []).forEach(function (v) {
      if (String(v.id) === result.variantId) variant = v;
    });
    var priceText = "";
    if (fromJs) {
      var v0 = variant || (p.variants || [])[0];
      if (v0 && isFinite(v0.price)) priceText = money(v0.price) + " ex VAT";
    } else if (p.price_min || p.price) {
      priceText = "From £" + (p.price_min || p.price) + " ex VAT";
    }
    var available = variant ? variant.available !== false : p.available !== false;
    return {
      handle: p.handle,
      title: p.title,
      image: absoluteImage(fromJs ? p.featured_image : p.image || (p.featured_image && p.featured_image.url), 120),
      variantId: result.variantId,
      variantTitle: variant && variant.title && variant.title !== "Default Title" ? variant.title : "",
      priceText: priceText,
      available: available,
      score: result.score,
    };
  }

  function findMatch(text) {
    if (!matcher) return Promise.resolve(null);
    return paced(suggestUrl(text, 6))
      .then(function (data) {
        var found = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var inputs = found.map(function (p) {
          var item = matchInput(p);
          item.source = p;
          return item;
        });
        var top = matcher.pickBest(text, inputs);
        if (top) return describeMatch(top.product.source, top.result, false);
        var maybe = matcher.shortlist(text, found, 1)[0];
        if (!maybe) return null;
        return paced("/products/" + encodeURIComponent(maybe.handle) + ".js").then(function (full) {
          var result = matcher.scoreProduct(text, matchInput(full));
          return result ? describeMatch(full, result, true) : null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function clearMatch(line) {
    if (line.slot) line.slot.textContent = "";
  }

  function checkMatch(line) {
    var text = lineTitle(line);
    if (line.kind !== "text" || !line.slot) return;
    if (text.length < 4 || line.checkedFor === text) {
      if (text.length < 4) clearMatch(line);
      return;
    }
    line.checkedFor = text;
    clearMatch(line);
    findMatch(text).then(function (match) {
      if (!match || lineTitle(line) !== text || lines.indexOf(line) === -1) return;
      if ((line.declined || []).indexOf(match.handle) > -1) return;
      showMatch(line, match);
    });
  }

  function absoluteImage(src, width) {
    var image = src || "";
    if (image && image.indexOf("//") === 0) image = "https:" + image;
    if (image && image.indexOf("cdn.shopify.com") > -1) image += (image.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
    return image;
  }

  function showMatch(line, match) {
    clearMatch(line);
    var meta = [];
    if (match.variantTitle) meta.push(match.variantTitle);
    if (match.priceText) meta.push(match.priceText);
    meta.push(match.available ? "In stock" : "Out of stock");
    var yes = el("button", { type: "button", class: "tte-btn tte-btn--small", text: "Use this product" });
    var no = el("button", { type: "button", class: "tte-btn tte-btn--ghost tte-btn--small", text: "No, keep what I typed" });
    var card = el("div", { class: "tte-match", role: "group", "aria-label": "Possible match from our catalogue" }, [
      el("p", { class: "tte-match__lead", text: "We stock something very close to this" }),
      el("div", { class: "tte-match__body" }, [
        match.image ? el("img", { src: match.image, alt: "", width: "48", height: "48", loading: "lazy" }) : null,
        el("div", { class: "tte-match__text" }, [
          el("a", { class: "tte-match__title", href: "/products/" + match.handle, target: "_blank", rel: "noopener", text: match.title }),
          el("span", { class: "tte-match__meta", text: meta.join(" · ") }),
        ]),
      ]),
      el("div", { class: "tte-match__actions" }, [yes, no]),
    ]);
    line.slot.appendChild(card);
    yes.addEventListener("click", function () {
      acceptMatch(line, match);
    });
    no.addEventListener("click", function () {
      line.declined = (line.declined || []).concat(match.handle);
      line.declinedTitle = match.title;
      clearMatch(line);
      if (line.titleInput) line.titleInput.focus();
      changed();
    });
  }

  function acceptMatch(line, match) {
    var index = lines.indexOf(line);
    var extra = { note: line.note || "", requested: lineTitle(line), index: index };
    var qty = line.qty;
    lines.splice(index, 1);
    if (line.node) line.node.remove();
    addProductByHandle(match.handle, match.variantId || null, qty, match.image, extra).catch(function () {
      addLine(
        { kind: "product", handle: match.handle, title: match.title, image: match.image, variantId: match.variantId || "", qty: qty, note: extra.note, requested: extra.requested, priceText: match.priceText },
        false,
        index,
      );
    });
  }

  /* ---------- Turn a pasted list into line items ---------- */

  function convertList() {
    if (!matcher) return;
    var rows = (listEl.value || "").split(/\r?\n/);
    var room = 40 - lines.length;
    var made = 0;
    var left = [];
    rows.forEach(function (row) {
      var parsed = matcher.parseListLine(row);
      if (!parsed || !parsed.title) return;
      if (made >= room) {
        left.push(row);
        return;
      }
      var line = { kind: "text", title: parsed.title.slice(0, 200), qty: clampQty(parsed.qty), note: "", declined: [] };
      addLine(line, true);
      made += 1;
      checkMatch(line);
    });
    listEl.value = left.join("\n");
    listCount.textContent = left.length
      ? left.length + " lines left. You can have up to 40 line items, so send these in a second request or leave them in the list."
      : "";
    changed();
    if (made) {
      linesEl.scrollIntoView({ block: "start", behavior: "smooth" });
      statusMessage(
        made + (made === 1 ? " item" : " items") + " added from your list. Check quantities and any suggested products below.",
      );
    }
  }

  var statusEl = null;
  function statusMessage(text) {
    if (!statusEl) {
      statusEl = el("p", { class: "tte-status", role: "status" });
      linesEl.parentNode.insertBefore(statusEl, linesEl);
    }
    statusEl.textContent = text;
    statusEl.hidden = !text;
  }

  convertBtn.addEventListener("click", convertList);

  fileInput.addEventListener("change", function () {
    var file = fileInput.files && fileInput.files[0];
    if (!file) return;
    if (file.size > 200000) {
      statusMessage("That file is too large. Please paste the list instead, or email it to us.");
      fileInput.value = "";
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      var text = String(reader.result || "").replace(/\r\n?/g, "\n").replace(/\u0000/g, "");
      listEl.value = (listEl.value ? listEl.value.replace(/\s+$/, "") + "\n" : "") + text.slice(0, 4000);
      pasteEl.open = true;
      listEl.dispatchEvent(new Event("input", { bubbles: true }));
      fileInput.value = "";
    };
    reader.readAsText(file);
  });

  /* ---------- Related products ---------- */

  var recsFor = null;

  function paintRecs(products) {
    recsList.textContent = "";
    var added = {};
    lines.forEach(function (l) {
      if (l.productId) added[String(l.productId)] = true;
    });
    var shown = (products || [])
      .filter(function (p) {
        return p.available !== false && !added[String(p.id)];
      })
      .slice(0, 4);
    recsEl.hidden = !shown.length;
    shown.forEach(function (p) {
      var image = absoluteImage(p.featured_image || p.image, 96);
      var price = isFinite(p.price) ? money(p.price) + " ex VAT" : "";
      var btn = el("button", { type: "button", class: "tte-btn tte-btn--ghost tte-btn--small", "aria-label": "Add " + p.title, text: "Add" });
      var item = el("li", { class: "tte-rec" }, [
        image ? el("img", { src: image, alt: "", width: "48", height: "48", loading: "lazy" }) : el("span", { class: "tte-opt-ph", text: "?" }),
        el("span", { class: "tte-rec__text" }, [el("strong", { text: p.title }), price ? el("small", { text: price }) : null]),
        btn,
      ]);
      btn.addEventListener("click", function () {
        btn.disabled = true;
        addProductByHandle(p.handle, null, 1, p.featured_image || p.image)
          .then(function () {
            item.remove();
            if (!recsList.children.length) recsEl.hidden = true;
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
      recsList.appendChild(item);
    });
  }

  function loadRecs(productId) {
    recsFor = String(productId);
    paced("/recommendations/products.json?product_id=" + encodeURIComponent(productId) + "&limit=8&intent=related")
      .then(function (data) {
        if (recsFor !== String(productId)) return;
        paintRecs((data && data.products) || []);
      })
      .catch(function () {
        if (recsFor === String(productId)) recsEl.hidden = true;
      });
  }

  /* ---------- Items already in the visitor's basket ---------- */

  var basket = [];

  function loadBasket() {
    paced("/cart.js")
      .then(function (cart) {
        basket = (cart && cart.items) || [];
        var units = basket.reduce(function (sum, item) {
          return sum + (item.quantity || 0);
        }, 0);
        if (!basket.length) return;
        cartCount.textContent = basket.length + (basket.length === 1 ? " item" : " items") + ", " + units + " units";
        addCartBtn.hidden = false;
      })
      .catch(function () {});
  }

  addCartBtn.addEventListener("click", function () {
    addCartBtn.disabled = true;
    basket
      .reduce(function (prev, item) {
        return prev.then(function () {
          return addProductByHandle(item.handle, item.variant_id, item.quantity, item.image).catch(function () {
            addLine({ kind: "product", handle: item.handle, title: String(item.product_title || item.handle).slice(0, 200), variantId: item.variant_id, qty: item.quantity || 1, note: "" }, true);
          });
        });
      }, Promise.resolve())
      .then(function () {
        addCartBtn.hidden = true;
        statusMessage("Your basket items are on the list. Change quantities to what you need for your quote.");
      });
  });

  addCustomBtn.addEventListener("click", function () {
    addBlankCustomLine();
  });

  /* ---------- Other fields ---------- */

  function paintFulfilment() {
    postcodeField.hidden = radio("fulfilment") === "collect";
  }

  form.addEventListener("change", function (event) {
    if (event.target.name === "fulfilment") paintFulfilment();
    changed();
  });
  form.addEventListener("input", function (event) {
    if (event.target === listEl) {
      var n = pastedCount();
      listCount.textContent = n ? n + (n === 1 ? " line" : " lines") + " pasted" : "";
    }
    clearError(event.target.name);
    changed();
  });

  var dateInput = form.elements.neededBy;
  (function () {
    var d = new Date();
    var pad = function (n) {
      return (n < 10 ? "0" : "") + n;
    };
    dateInput.min = d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
  })();

  /* ---------- Errors and submit ---------- */

  function errorNode(name) {
    return root.querySelector('[data-tte-err="' + name + '"]');
  }

  function showError(name, message, field) {
    var node = errorNode(name);
    if (node) {
      node.textContent = message;
      node.hidden = false;
    }
    if (field) field.setAttribute("aria-invalid", "true");
  }

  function clearError(name) {
    if (!name) return;
    var node = errorNode(name);
    if (node) node.hidden = true;
    var field = form.elements[name];
    if (field && field.removeAttribute) field.removeAttribute("aria-invalid");
    var general = errorNode("form");
    if (general) general.hidden = true;
  }

  function validate() {
    var f = form.elements;
    var first = null;
    ["name", "email", "consent", "form"].forEach(function (k) {
      var node = errorNode(k);
      if (node) node.hidden = true;
    });
    [f.name, f.email].forEach(function (x) {
      x.removeAttribute("aria-invalid");
    });

    if (!activeLines().length && !listEl.value.trim() && !f.notes.value.trim()) {
      showError("form", "Add at least one item, paste a list, or tell us what you need in the notes.", null);
      first = first || q;
    }
    if (f.name.value.trim().length < 2) {
      showError("name", "Please tell us your name.", f.name);
      first = first || f.name;
    }
    var email = f.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError("email", "Please enter an email address we can reply to.", f.email);
      first = first || f.email;
    }
    if (!f.consent.checked) {
      showError("consent", "Please tick the box so we can reply to you.", null);
      first = first || f.consent;
    }
    if (first) {
      first.scrollIntoView({ block: "center", behavior: "smooth" });
      first.focus({ preventScroll: true });
      return false;
    }
    return true;
  }

  function attribution() {
    var out = {};
    var keys = ["gclid", "gbraid", "wbraid", "fbclid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    var params = new URLSearchParams(window.location.search);
    var stored = {};
    try {
      stored = JSON.parse(sessionStorage.getItem("ts-trade-attr") || "{}");
    } catch (e) {
      stored = {};
    }
    keys.forEach(function (k) {
      var value = params.get(k) || stored[k];
      if (value) out[k] = String(value).slice(0, 200);
    });
    try {
      sessionStorage.setItem("ts-trade-attr", JSON.stringify(out));
    } catch (e) {
      /* ignore */
    }
    return out;
  }
  attribution();

  function payload() {
    var f = form.elements;
    var body = {
      contact: {
        name: f.name.value.trim(),
        email: f.email.value.trim(),
        customerType: radio("customerType") || "other",
      },
      lines: activeLines().map(function (l) {
        var item = { title: l.title.trim().slice(0, 200), quantity: l.qty };
        var v = selectedVariant(l);
        if (v) item.variantId = String(v.id);
        else if (l.variantId) item.variantId = String(l.variantId);
        else if (l.handle) item.handle = l.handle;
        if (l.note && l.note.trim()) item.note = l.note.trim();
        if (l.kind === "text") {
          if (l.reference && l.reference.trim()) item.reference = l.reference.trim().slice(0, 300);
          if (l.alt) item.alternativesOk = true;
          if (l.declinedTitle) item.declinedMatch = String(l.declinedTitle).slice(0, 200);
        }
        if (l.requested) item.requested = String(l.requested).slice(0, 200);
        return item;
      }),
      timing: radio("timing") || "flexible",
      frequency: radio("frequency") || "unsure",
      fulfilment: radio("fulfilment") || "delivery",
      consent: true,
      submissionId: submissionId,
      pageUrl: window.location.origin + window.location.pathname,
      attribution: attribution(),
    };
    if (f.phone.value.trim()) body.contact.phone = f.phone.value.trim();
    if (f.company.value.trim()) body.contact.company = f.company.value.trim();
    if (listEl.value.trim()) body.pastedList = listEl.value.trim().slice(0, 4000);
    if (f.notes.value.trim()) body.notes = f.notes.value.trim();
    if (f.neededBy.value) body.neededBy = f.neededBy.value;
    if (f.postcode.value.trim() && body.fulfilment === "delivery") body.postcode = f.postcode.value.trim();
    var hp = f.website.value;
    if (hp) body.website = hp;
    return body;
  }

  function track(body) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (typeof window.gtag !== "function" || !privacy) return;
      if (privacy.analyticsProcessingAllowed()) {
        window.gtag("event", "generate_lead", {
          send_to: "G-CT6V623E05",
          lead_source: "trade_form",
          items: body.lines.length,
          custom_items: body.lines.filter(function (l) {
            return !l.variantId && !l.handle;
          }).length,
          urgent: body.timing === "asap" ? 1 : 0,
          transport_type: "beacon",
        });
      }
    } catch (e) {
      /* tracking must never get in the way of the enquiry */
    }
  }

  function fallbackToContactForm(body, text) {
    var data = new URLSearchParams();
    data.set("form_type", "contact");
    data.set("utf8", "✓");
    data.set("contact[name]", body.contact.name);
    data.set("contact[email]", body.contact.email);
    if (body.contact.phone) data.set("contact[phone]", body.contact.phone);
    data.set("contact[body]", text);
    return fetch(contactAction, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: data.toString(),
    }).catch(function () {});
  }

  function setBusy(on) {
    submitting = on;
    submitBtn.disabled = on;
    submitLabel.textContent = on ? "Sending…" : "Request my quote";
  }

  function showSuccess(result, body) {
    var first = body.contact.name.split(/\s+/)[0];
    root.querySelector("[data-tte-success-title]").textContent = "Thanks " + first + ", we have your enquiry";
    root.querySelector("[data-tte-success-ref]").textContent = result.reference && result.reference !== "pending" ? result.reference : "received";
    root.querySelector("[data-tte-success-mail]").textContent = result.emailed
      ? "We have emailed you a copy at " + body.contact.email + "."
      : "";
    root.classList.add("is-done");
    successEl.hidden = false;
    bar.hidden = true;
    successEl.scrollIntoView({ block: "start", behavior: "smooth" });
    successEl.focus({ preventScroll: true });
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (submitting || !validate()) return;
    var body = payload();
    setBusy(true);
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (json) {
          return { ok: r.ok && json && json.ok, json: json || {} };
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.error || "");
        var done = res.json.fallbackMessage ? fallbackToContactForm(body, res.json.fallbackMessage) : Promise.resolve();
        return done.then(function () {
          track(body);
          clearSaved();
          showSuccess(res.json, body);
        });
      })
      .catch(function (e) {
        showError(
          "form",
          (e && e.message) ||
            "We could not send your request. Please email info@tourstock.co.uk or call 020 3397 1767 and we will pick it up straight away.",
          null
        );
      })
      .then(function () {
        setBusy(false);
      });
  });

  /* ---------- Reset, bar, deep links ---------- */

  function reset() {
    lines = [];
    linesEl.textContent = "";
    listEl.value = "";
    listCount.textContent = "";
    recsEl.hidden = true;
    recsFor = null;
    if (statusEl) statusEl.hidden = true;
    form.elements.notes.value = "";
    form.elements.neededBy.value = "";
    form.elements.consent.checked = false;
    submissionId = newId();
    root.classList.remove("is-done");
    successEl.hidden = true;
    changed();
    root.scrollIntoView({ block: "start", behavior: "smooth" });
  }
  root.querySelector("[data-tte-again]").addEventListener("click", reset);

  root.querySelector("[data-tte-bar-go]").addEventListener("click", function () {
    var target = form.elements.name;
    target.scrollIntoView({ block: "center", behavior: "smooth" });
    target.focus({ preventScroll: true });
  });

  if ("IntersectionObserver" in window) {
    new IntersectionObserver(
      function (entries) {
        barHidden = entries[0].isIntersecting;
        paintBar();
      },
      { threshold: 0.1 }
    ).observe(submitBtn);
  }

  function deepLink() {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get("item");
    var text = params.get("q");
    var qty = parseInt(params.get("qty"), 10);
    if (handle) {
      return addProductByHandle(handle, params.get("variant"), isFinite(qty) && qty > 0 ? qty : 1).catch(function () {
        var wanted = params.get("variant");
        addHandleLine(
          { handle: handle, title: text || handle.replace(/-/g, " ") },
          isFinite(qty) && qty > 0 ? qty : 1,
          wanted && /^\d+$/.test(wanted) ? wanted : "",
        );
      });
    }
    if (text) addTextLine(text);
    return Promise.resolve();
  }

  loadBasket();
  paintFulfilment();
  var restored = restore();
  paintFulfilment();
  paintSummary();
  deepLink().then(function () {
    if (!restored) paintSummary();
    var n = pastedCount();
    if (n) listCount.textContent = n + (n === 1 ? " line" : " lines") + " pasted";
  });
})();
